import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const { currentUser, isAdmin } = useAuth();
  const navigate = useNavigate();

  if (!currentUser) {
    navigate('/auth/login');
    return null;
  }

  return (
    <div className="profile-section">
      <div className="container">
        <div className="profile-container">
          <div className="profile-header">
            <div className="profile-avatar-wrapper">
              <img 
                src={`https://cdn.discordapp.com/avatars/${currentUser.id}/${currentUser.avatar}.png`} 
                alt="Profile" 
                className="profile-avatar"
              />
            </div>
            <h1>{currentUser.username}</h1>
            <div className="user-role">{isAdmin ? 'Admin' : 'Kullanıcı'}</div>
          </div>

          <div className="profile-info">
            <div className="info-section">
              <h2>Hesap Bilgileri</h2>
              <div className="info-grid">
                <div className="info-item">
                  <span className="info-label">Discord ID</span>
                  <span className="info-value">{currentUser.id}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Kullanıcı Adı</span>
                  <span className="info-value">{currentUser.username}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">E-posta</span>
                  <span className="info-value">{currentUser.email || 'Gizli'}</span>
                </div>
              </div>
            </div>

            {isAdmin && (
              <div className="admin-section">
                <h2>Admin Paneli</h2>
                <p>Admin paneline erişim yetkiniz bulunmaktadır.</p>
                <button 
                  className="btn primary"
                  onClick={() => navigate('/admin')}
                >
                  Admin Paneline Git
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile; 